<acabim-datatable
    #dataTable
    [dataSources]="[this]"
    [dataKey]="'id'"
    [hasDetailView]="false">
</acabim-datatable>
